/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudProviderEnum } from './cloudProviderEnum';
import { ScriptTypeEnum } from './scriptTypeEnum';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { ScriptRunnerRoleEnum } from './scriptRunnerRoleEnum';
import { ScriptRunnerComponentTypeEnum } from './scriptRunnerComponentTypeEnum';


/**
 * Full content of manifest.yaml stored in script storage (S3). Required fields (script_path, name, script_type, executes_on_managed_instances, roles) must be present in every manifest. Optional fields (target_cloud, service_type, components, enabled) carry sensible defaults and may be omitted.
 */
export interface ScriptManifest { 
    /**
     * Relative path to the script entry point within its storage folder (e.g. \"script_main.py\" or \"script_main.sh\"). Must not start with \"/\" or contain \"..\".
     */
    script_path: string;
    /**
     * Display name shown in the UI.
     */
    name: string;
    script_type: ScriptTypeEnum;
    /**
     * Whether this script runs on SSM-managed EC2 instances (true) or on VCF ACC (false). Governs which execution path is used at runtime.
     */
    executes_on_managed_instances: boolean;
    /**
     * Cloud providers this script targets. Defaults to [AWS] when not specified. Used to filter which scripts are eligible for a given execution request.
     */
    target_cloud: Array<CloudProviderEnum>;
    /**
     * Service types this script applies to. Defaults to [VCDR] when not specified. Used alongside target_cloud to scope script execution.
     */
    service_type: Array<ServiceTypeEnum>;
    /**
     * RBAC role names that are permitted to invoke this script. An empty list means the script is accessible to all authenticated operators. Allowed values are vcds:ro-script-run and vcds:rw-script-run.
     */
    roles: Array<ScriptRunnerRoleEnum>;
    /**
     * Product components this script applies to. Defaults to [IRR, CDVX] when not specified. Controls which component-type execution targets are eligible.
     */
    components: Array<ScriptRunnerComponentTypeEnum>;
    /**
     * Whether this script is active and eligible for execution. Defaults to true when not specified. Disabled scripts are excluded from registry queries and execution requests.
     */
    enabled: boolean;
    /**
     * Human-readable description of what the script does.
     */
    description?: string;
    /**
     * Supported product or component version strings. May be used to restrict execution to compatible deployment versions.
     */
    supported_versions?: Array<string>;
    /**
     * OpenAPI YAML fragment or structured list describing the script\'s accepted parameter definitions. Used for UI form rendering and pre-commit hook validation. May be a list of parameter objects, a plain string, or a structured object.
     */
    parameters?: any | null;
    /**
     * JSON Schema blob describing the expected structure of this script\'s output. Can be used to collate and validate execution results across targets.
     */
    output_json_schema?: { [key: string]: any; };
}
export namespace ScriptManifest {
}


